'use strict';

module.exports = strong;

var all = require('../all');

function strong(h, node) {
  return h(node, 'strong', all(h, node));
}



//////////////////
// WEBPACK FOOTER
// ../node_modules/hast-util-to-mdast/handlers/strong.js
// module id = 1023
// module chunks = 0